"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicTitle = void 0;
const vue_1 = require("vue");
const utils_1 = require("../../utils/utils");
exports.DynamicTitle = vue_1.default.component('dynamic-title', {
    props: {
        title: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        withAdditional: {
            type: Boolean,
            default: false,
        },
        additional: {
            type: [String, Number],
            default: '',
        },
    },
    methods: {
        getClasses: function () {
            return [
                utils_1.playerColorClass(this.color, 'shadow'),
                'dynamic-title',
            ].join(' ');
        },
    },
    template: `
        <div :class="getClasses()"><span v-i18n>{{ title }}</span><span v-if="withAdditional" class="label-additional">{{ additional }}</span></div>
    `,
});
//# sourceMappingURL=DynamicTitle.js.map